import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=b48d6df6&scoped=true&"
import script from "./Label.vue?vue&type=script&lang=ts&"
export * from "./Label.vue?vue&type=script&lang=ts&"
import style0 from "./Label.vue?vue&type=style&index=0&id=b48d6df6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48d6df6",
  null
  
)

export default component.exports